module.exports = __webpack_public_path__ + "static/media/1009308.c0fe30c0.png";